module.exports = __webpack_public_path__ + "static/media/LogoHelenLabs.e44de8a1.svg";